export const returnLabel = (labelArray = [], key) => {
    return labelArray.find((x) => x.Key === key)?.Phrase || "";
};

export const getClientAccountCmsFetchers = (refClientAccountCmsData) => {
    const getLabelByComponent = (componentKey, key) => {
        const labels = refClientAccountCmsData?.Components?.[componentKey]?.Labels;
        return returnLabel(labels, key);
    };

    return {
        fetchClientAccountCmsData: (key) =>
            getLabelByComponent("ClientAccountDetails.SetupClientAccount", key),
        fetchClientTeamMemberCmsData: (key) =>
            getLabelByComponent("ClientAccounts.ClientTeamMembers", key),
        fetchAccountTeamMemberCmsData: (key) =>
            getLabelByComponent("ClientAccounts.AccountTeamMembers", key),
        fetchAccountAdmnCmsData: (key) =>
            getLabelByComponent("ClientAccounts.AccountAdmins", key),
    };
};
